import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexFloristPageHeader = ({
  page,
  hasLogoImage,
  hasBannerImage,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div
      className={cn('mb-fluid-6 text-page-text', {
        'lg:pt-fluid-10': !forceMobile,
      })}
    >
      <div
        className={cn('relative', {
          'pt-fluid-28': !hasBannerImage,
        })}
      >
        <HeaderBanner
          media={page?.bannerMedia}
          className="h-fluid-80 w-full"
          {...props}
        />

        <HeaderLogo
          media={page?.logoMedia}
          {...props}
          className="absolute -bottom-fluid-11 left-1/2 -translate-x-1/2 rounded-[13px]"
          sizeClassName="size-fluid-28"
          size={112}
        />
      </div>

      <div
        className={cn('flex flex-col space-y-fluid-4 px-fluid-4 pt-fluid-5', {
          'pt-fluid-14!': hasLogoImage,
        })}
      >
        <HeaderName
          name={page?.name}
          {...props}
          className="text-center text-fluid-3xl"
        />

        <HeaderDescription
          description={page?.description}
          {...props}
          className="text-center text-fluid-base"
        />

        <HeaderSocialIcons
          socialIcons={page?.socialIcons}
          {...props}
          className="mt-fluid-5! justify-center"
          primaryClassName="p-fluid-4 page-header-primary-button flex-1"
          secondaryClassName="p-fluid-4 page-header-secondary-button"
          showPrimaryLabel
        />
      </div>
    </div>
  )
}
